import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
/**
 * Action Button Component
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since v0.0.1
 */
let ActionButtonIndex = class ActionButtonIndex extends Vue {
    get btnText() {
        return this.iconBtn ? '' : this.actionText || 'Submit';
    }
    /**
     * Apply Styles Based on Props
     */
    styles() {
        return {
            '-submit': this.submit,
            '-cancel': this.cancel,
            '-edit': this.edit,
            '-delete': this.remove,
            '-add': this.add,
            '-flat': this.flat,
            '-warning': this.warning,
            '-orange-theme': this.orangeTheme,
            '-orange-inverse': this.orangeInverse,
            '-skip': this.skip,
            '-blue-theme': this.blueTheme,
            '-common': this.common,
            '-short': this.short,
            '-small': this.smBtn,
            '-extra-small': this.xsBtn,
            '-view': this.view,
            '-list-action': this.listAction,
            '-settings': this.settings,
            '-icon': this.iconBtn,
            '-transparent-theme': this.transparentTheme,
            '-blue-border': this.blueBorder,
            '-activate': this.fbActivation,
            '-medium': this.mdBtn,
            '-large': this.lgBtn,
            'text-capitalize': this.capTxt,
            'mr-0': this.mr0,
            'ma-0': this.ma0,
            '-orange-transparent': this.orangeTransparent,
            '-block': this.block,
            'px-2': this.px2,
            '-red-transparent': this.redTransparent,
            '-cyan-transparent': this.cyanTransparent,
            '-lightgreen-transparent': this.lightGreenTransparent,
            '-rounded': this.rounded,
            'mx-2': this.mx2,
            'my-0': this.my0,
            '-white-transparent': this.whiteTransparent,
            '-extra-large': this.xlgBtn,
        };
    }
    /**
     * Trigger Event upon click
     */
    wasClicked() {
        /**
         * Triggered Event upon click
         * @event wasClicked
         * @type { never }
         */
        this.$emit('wasClicked');
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "submit", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "cancel", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "edit", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "remove", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "disable", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "add", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "flat", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "orangeTheme", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "orangeInverse", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "warning", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "skip", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "blueTheme", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "common", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "short", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "smBtn", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "xsBtn", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "view", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "outline", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "listAction", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "settings", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "iconBtn", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ActionButtonIndex.prototype, "actionText", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ActionButtonIndex.prototype, "icon", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "transparentTheme", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "redTransparent", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "cyanTransparent", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "lightGreenTransparent", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "blueBorder", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "fbActivation", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "mdBtn", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "lgBtn", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "xlgBtn", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], ActionButtonIndex.prototype, "capTxt", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "mr0", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "ma0", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "mx2", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "my0", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "whiteTransparent", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "orangeTransparent", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "block", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "px2", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ActionButtonIndex.prototype, "rounded", void 0);
ActionButtonIndex = __decorate([
    Component({
        name: 'ActionButton',
    })
], ActionButtonIndex);
export default ActionButtonIndex;
